export default "__VITE_ASSET__B5kzO1mu__"